import { createReducer, on } from '@ngrx/store';
import * as fromPaymentsActions from '../actions';
import { IGenerateRefundStatementResponse } from '../models/generate-refund-statement-response.model';

export const generateRefundStatementFeatureKey = 'generateRefundStatement';

export interface GenerateRefundStatementState {
  success: IGenerateRefundStatementResponse | null;
  failure: any | null;
  loading: boolean;
}

export const initialState: GenerateRefundStatementState = {
  success: null,
  failure: null,
  loading: false
};

export const generateRefundStatementReducer = createReducer(
  initialState,
  on(fromPaymentsActions.generateRefundStatement, (state) => ({
    ...state,
    success: null,
    failure: null,
    loading: true
  })),
  on(fromPaymentsActions.generateRefundStatementSuccess, (state, { response }) => ({
    ...state,
    success: response,
    failure: null,
    loading: false
  })),
  on(fromPaymentsActions.generateRefundStatementFailure, (state, { error }) => ({
    ...state,
    success: null,
    failure: error,
    loading: false
  }))
);
